export default __webpack_public_path__ + "b2522714cbf0e33661acc0fa483130c8.svg";